export type CarrierInitializationSurface =
  | 'overview'
  | 'organizer'
  | 'audit_review'
  | 'rate_summary'
  | 'customer_rate_summary'
  | 'traffic_performance';

export interface TrafficPerformanceSurface {
  kind: 'traffic_performance';
  version: 2;
  draftId: string;
}

export type CarrierInitializationSurfaceResult =
  | CarrierInitializationSurface
  | TrafficPerformanceSurface;

const SURFACE_CONTENT: Record<CarrierInitializationSurface, string> = {
  overview: '<telcoos-application-surface kind="carrier_initialization_overview" version="1" />',
  organizer: '<telcoos-application-surface kind="carrier_organizer" version="1" />',
  audit_review: '<telcoos-application-surface kind="carrier_audit_review" version="1" />',
  rate_summary: '<telcoos-application-surface kind="domestic_service_rate_summary" version="1" />',
  customer_rate_summary: '<telcoos-application-surface kind="domestic_customer_rate_summary" version="1" />',
  traffic_performance: '<telcoos-application-surface kind="domestic_traffic_performance" version="1" />',
};

export function parseCarrierInitializationSurface(
  content: string
): CarrierInitializationSurfaceResult | null {
  const normalized = content.trim();
  if (normalized === SURFACE_CONTENT.overview) return 'overview';
  if (normalized === SURFACE_CONTENT.organizer) return 'organizer';
  if (normalized === SURFACE_CONTENT.audit_review) return 'audit_review';
  if (normalized === SURFACE_CONTENT.rate_summary) return 'rate_summary';
  if (normalized === SURFACE_CONTENT.customer_rate_summary) return 'customer_rate_summary';
  if (normalized === SURFACE_CONTENT.traffic_performance) return 'traffic_performance';
  const trafficPerformance = normalized.match(
    /^<telcoos-application-surface kind="domestic_traffic_performance" version="2" draft-id="([A-Za-z0-9_-]+)" \/>$/
  );
  if (trafficPerformance) {
    return {
      kind: 'traffic_performance',
      version: 2,
      draftId: trafficPerformance[1],
    };
  }
  return null;
}

export function isSupersededTrafficPerformanceSurface(
  contents: string[],
  index: number,
): boolean {
  if (parseCarrierInitializationSurface(contents[index] ?? '') !== 'traffic_performance') {
    return false;
  }
  return contents.slice(index + 1).some((content) => {
    const surface = parseCarrierInitializationSurface(content);
    return surface !== null
      && typeof surface === 'object'
      && surface.kind === 'traffic_performance'
      && surface.version === 2;
  });
}
